import Cookies from "js-cookie";

export const defaultMandatoryFields = [
  {
    name: "gclid",
    value: Cookies.get("gclid") || "",
  },
  {
    name: "utm_source",
    value: Cookies.get("utmSource") || "organic",
  },
  {
    name: "utm_medium",
    value: Cookies.get("utmMedium") || "",
  },
  {
    name: "utm_campaign",
    value: Cookies.get("utmCampaign") || "",
  },
  {
    name: "utm_content",
    value: Cookies.get("utmContent") || "",
  },
  {
    name: "utm_term",
    value: Cookies.get("utmTerm") || "",
  },
];

export function createFormDataToSend(values, formItemsToSend) {
  const fields = [];

  Object.keys(values).forEach((key) => {
    if (formItemsToSend.includes(key)) {
      fields.push({
        name: key,
        value: values[key] === undefined ? false : values[key],
      });
    }
  });

  return {
    fields: [...fields, ...defaultMandatoryFields],
    context: {
      hutk: Cookies.get("hubspotutk") || undefined,
      pageUri: window.location.href,
      pageName: document.title,
    },
  };
}

export function createMarginCalculatorFormDataToSend(values) {
  return {
    // fields: values,
    fields: [...values, ...defaultMandatoryFields],
    context: {
      hutk: Cookies.get("hubspotutk") || undefined,
      pageUri: window.location.href,
      pageName: document.title,
    },
  };
}

const venues = ["enterprise"];
const restaurantAndHospitality = ["restaurant"];

export function extractDefaultValues(formData) {
  if (!formData) {
    return {};
  }

  const defaultValues = {};

  formData.forEach((item) => {
    if (item.defaultValue) {
      defaultValues[item.name] = item.defaultValue;
    }
  });

  return defaultValues;
}

export function getSubmittedOn() {
  const currentDate = new Date();
  const submittedOn = `${
    currentDate.getMonth() + 1
  }-${currentDate.getDate()}-${currentDate.getFullYear()}`;

  return submittedOn;
}

export function getSubmittedOnAndConversionId() {
  return {
    submitted_on: getSubmittedOn(),
    conversion_id: Date.now().toString(),
  };
}
